import { IUpdateUserRequest, IUser, IUserListingResponse } from '@core/models/user-listing.model';
import { ApiProvider } from '@reduxjs/toolkit/dist/query/react';
import { AxiosResponse } from 'axios';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class userListing {
    private readonly getAllUsersURL = `/admin/filter-users`;
    private readonly deActivateUserURL = `/admin/activation_user/`;
    private readonly deleteUserURL = `/admin/delete_user_by_id/`;
    private readonly addWalletToUserURL = `/wallet/add_wallet`;
    private readonly updateUserURL = `/admin/update_user_term_&&_tier`;
    private readonly getUserByIdURL = `/admin/filter-users`;
    private readonly exportUsersURL = `/export/users`;
    private readonly updateWalletBalanceURL = `/wallet/increase_amount`;

    getAllUsers(
        pageNumber: string,
        pageSize: string,
        userId?: string,
        tier?: string,
        accountType?: string,
        isAccountStatus?: boolean,
        email?: string
    ): Promise<AxiosResponse<IUserListingResponse>> {
        return fetchWithRetry(
            API.get(this.getAllUsersURL, {
                params: {
                    pageNumber,
                    pageSize,
                    userId,
                    tier,
                    accountType,
                    isAccountStatus,
                    email,
                },
            })
        );
    }

    getUserById(userId: string): Promise<AxiosResponse<any>> {
        return fetchWithRetry(
            API.get(this.getUserByIdURL, {
                params: {
                    userId,
                },
            })
        );
    }

    deActivateUser(userId: string, activate: boolean): Promise<AxiosResponse<any>> {
        return fetchWithRetry(
            API.patch(`${this.deActivateUserURL}${userId}`, null, {
                params: {
                    activate,
                },
            })
        );
    }

    deleteUser(userId: string): Promise<AxiosResponse<any>> {
        return fetchWithRetry(API.delete(`${this.deleteUserURL}${userId}`));
    }

    addWalletToUser(accountId: string, balance: number): Promise<AxiosResponse<any>> {
        return fetchWithRetry(
            API.post(`${this.addWalletToUserURL}`, {
                accountId,
                balance,
            })
        );
    }
    updateWalletBalance(accountId: string, balance: number): Promise<AxiosResponse<any>> {
        return fetchWithRetry(
            API.put(`${this.updateWalletBalanceURL}`, {
                accountId,
                balance,
            })
        );
    }

    updateUser(data: IUpdateUserRequest): Promise<AxiosResponse<any>> {
        const formData = new FormData();

        Object.keys(data).forEach((key) => {
            const value = data[key as keyof IUpdateUserRequest];
            if (value instanceof File) {
                formData.append(key, value);
            } else if (value !== undefined && value !== null && value !== '') {
                formData.append(key, String(value));
            }
        });

        return fetchWithRetry(
            API.patch(this.updateUserURL, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        );
    }

    exportUsers(accountType: string, isActive: boolean): Promise<AxiosResponse<any>> {
        return fetchWithRetry(
            API.post(this.exportUsersURL, {
                accountType,
                isActive,
            })
        );
    }
}

export default new userListing();
